import React, { Component } from 'react';

import './token.scss';

import { bool } from 'prop-types';

import { TokenAPI } from '@philips-emr/tws-components-api';
import { Type } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { eventListener, expression, oneOf } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { classNames, enumValues, isEnumValid, isFunction } from '@philips-emr/tws-utils';

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: TokenAPI })
class Token extends Component {

  static propTypes = {
    selected: bool,
    value: expression,
    type: oneOf(enumValues(Type)),
    onClick: eventListener,
    onDoubleClick: eventListener,
    onContextMenuClick: eventListener,
  };

  static defaultProps = {
    selected: false,
    text: '',
    type: Type.SAFETY,
  };

  onClick = () => {
    const { onClick, value } = this.props;

    isFunction(onClick) && onClick({ value });
  };

  onDoubleClick = () => {
    const { onDoubleClick } = this.props;

    isFunction(onDoubleClick) && onDoubleClick();
  };

  onContextMenuClick = () => {
    const { onContextMenuClick } = this.props;

    isFunction(onContextMenuClick) && onContextMenuClick();
  };

  render() {
    const { value, type, selected } = this.props;

    const rootClasses = {
      'c-token': true,
      'is-selected': selected,
      [`c-token--${type}`]: isEnumValid(Type, type),
    };

    return (
      <div className={classNames(rootClasses)} x-contrast="bd"
        onClick={this.onClick}
        onDoubleClick={this.onDoubleClick}
        onContextMenu={this.onContextMenuClick}
      >
        {msg(value)}
      </div>
    );
  }
}

export default Token;
